import React from 'react';

/**
 * Card component for wrapping content with modern fitness app styling
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.elevated - Whether to use elevated style
 * @param {boolean} props.interactive - Whether card is interactive (adds hover effects)
 * @param {boolean} props.noPadding - Remove default padding
 * @param {boolean} props.highlight - Add highlight styling
 * @param {boolean} props.fitnessStyling - Use Strava/Nike inspired styling
 * @param {React.ReactNode} props.children - Card content
 */
const Card = ({
  className = '',
  elevated = false,
  interactive = false,
  noPadding = false,
  highlight = false,
  fitnessStyling = false,
  children,
  ...rest
}) => {
  // Base styling
  const baseStyle = 'bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700';

  // Padding
  const paddingStyle = noPadding ? '' : 'p-4';

  // Shadow variants
  const shadowStyle = elevated
    ? 'shadow-fitness'
    : fitnessStyling
      ? 'shadow-card'
      : 'shadow-sm';

  // Interactive effects
  const interactiveStyle = interactive
    ? 'transition-all duration-200 hover:shadow-md hover:translate-y-[-2px] active:translate-y-[0px] cursor-pointer'
    : '';

  // Highlight effect
  const highlightStyle = highlight
    ? 'border-l-4 border-l-primary-500'
    : '';

  // Fitness app inspired styling
  const fitnessStyle = fitnessStyling
    ? 'bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900'
    : '';

  return (
    <div
      className={`${baseStyle} ${paddingStyle} ${shadowStyle} ${interactiveStyle} ${highlightStyle} ${fitnessStyle} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
